import { useGetAthletes, useGetAthletesInActivity, useGetDevicesInActivity } from 'api';
import { ActivityAthlete } from 'oas';
import * as React from 'react';
import { athleteInActivitySorter } from './athlete-in-activity-sorter';

export const useGetMappedAthletes = (activityId: string): ActivityAthlete[] | undefined => {
    const { data: devices } = useGetDevicesInActivity(activityId);
    const { data: athletes } = useGetAthletes();
    const { data: athletesInActivity } = useGetAthletesInActivity(activityId);

    return React.useMemo(() => {
        if (devices && athletes && athletesInActivity) {
            const athleteLookup: Record<string, ActivityAthlete> = athletes.reduce((index, athlete) => {
                const myAthlete = { ...athlete };
                // we only want participation tags from athletesInActivity, not athlete tags
                delete myAthlete.tag_list;
                delete myAthlete.tags;
                return { ...index, [athlete.id]: myAthlete };
            }, {});

            const athleteInActivityLookup: Record<string, ActivityAthlete> = athletesInActivity.reduce(
                (index, athlete) => ({ ...index, [athlete.id]: athlete }),
                {},
            );

            return devices
                .filter(
                    (device) =>
                        !!device.athlete_id &&
                        device.activity_dictionaries &&
                        device.activity_dictionaries.reduce<boolean>(
                            (hasData, actDic) => hasData || !!actDic.has_data,
                            false,
                        ),
                )
                .map((device) => ({
                    ...athleteLookup[device.athlete_id as string],
                    ...(athleteInActivityLookup[device.athlete_id as string] || {}),
                    device_info: {
                        device_id: device.device_id,
                        activity_dictionaries: device.activity_dictionaries,
                    },
                }))
                .sort(athleteInActivitySorter);
        }
    }, [devices, athletes, athletesInActivity]);
};
